"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Box = (0, _component.default)(function () {
  return import("@material-ui/core/Box");
});
var Grid = (0, _component.default)(function () {
  return import("@material-ui/core/Grid");
});
var Image = (0, _component.default)(function () {
  return import("./image");
});
var PlayArrowIcon = (0, _component.default)(function () {
  return import("@material-ui/icons/PlayArrow");
});
var ReactOverlay = (0, _component.default)(function () {
  return import("@micado-digital/react-overlay/ReactOverlay");
});
var Skeleton = (0, _component.default)(function () {
  return import("./skeleton");
});
var Typography = (0, _component.default)(function () {
  return import("@micado-digital/react-ui/components/Typography");
});
var Video = (0, _component.default)(function () {
  return import("./video");
});
var useStyles = (0, _makeStyles.default)(function (theme) {
  var _theme$palette, _theme$palette2;
  return {
    root: _defineProperty({
      background: "#FFFFFF",
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(2)
    }, theme.breakpoints.up("sm"), {
      display: "flex",
      flexWrap: "wrap",
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(3)
    }),
    wrapper: {
      cursor: "pointer",
      flex: 1,
      height: 0,
      overflow: "hidden",
      paddingBottom: "56.25%",
      paddingTop: 25,
      position: "relative",
      "& picture": {
        height: "100%",
        left: 0,
        position: "absolute",
        top: 0,
        width: "100%"
      }
    },
    imageWrapper: {
      bottom: 0,
      left: 0,
      position: "absolute",
      right: 0,
      top: 0,
      zIndex: 2
    },
    videoWrapper: {
      bottom: 0,
      left: 0,
      position: "absolute",
      right: 0,
      top: 0,
      zIndex: 1
    },
    isVideoVisible: {
      zIndex: 3
    },
    video: {
      height: "100%",
      width: "100%",
      "& video": {
        display: "block",
        objectFit: "cover"
      },
      "& iframe": {
        display: "block"
      }
    },
    player: {
      position: "relative",
      zIndex: 1
    },
    playIcon: {
      alignItems: "center",
      background: (_theme$palette = theme.palette) === null || _theme$palette === void 0 || (_theme$palette = _theme$palette.primary) === null || _theme$palette === void 0 ? void 0 : _theme$palette.main,
      borderRadius: "50%",
      display: "flex",
      height: 72,
      justifyContent: "center",
      left: "50%",
      position: "absolute",
      top: "50%",
      transform: "translate(-50%, -50%)",
      width: 72,
      "& svg path": {
        fill: theme.palette.getContrastText((_theme$palette2 = theme.palette) === null || _theme$palette2 === void 0 || (_theme$palette2 = _theme$palette2.primary) === null || _theme$palette2 === void 0 ? void 0 : _theme$palette2.main)
      }
    },
    content: _defineProperty({
      flex: 2,
      padding: theme === null || theme === void 0 ? void 0 : theme.spacing(3, 2)
    }, theme.breakpoints.up("md"), {
      paddingLeft: theme === null || theme === void 0 ? void 0 : theme.spacing(5)
    }),
    overlay: {
      "& .mco-video-02__video-player": {
        position: "relative",
        paddingBottom: "56.25%",
        height: 0,
        overflow: "hidden",
        "& iframe, video": {
          height: "100%",
          left: 0,
          position: "absolute",
          top: 0,
          width: "100%"
        }
      }
    }
  };
});
var ReactVideo02 = function ReactVideo02(_ref) {
  var _ref$additionComponen = _ref.additionComponent,
    additionComponent = _ref$additionComponen === void 0 ? "p" : _ref$additionComponen,
    _ref$additionVariant = _ref.additionVariant,
    additionVariant = _ref$additionVariant === void 0 ? "caption" : _ref$additionVariant,
    additionVariants = _ref.additionVariants,
    _ref$autoplay = _ref.autoplay,
    autoplay = _ref$autoplay === void 0 ? false : _ref$autoplay,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? false : _ref$loop,
    media = _ref.media,
    mediaFormats = _ref.mediaFormats,
    mediaPath = _ref.mediaPath,
    _ref$showInOverlay = _ref.showInOverlay,
    showInOverlay = _ref$showInOverlay === void 0 ? true : _ref$showInOverlay,
    skeleton = _ref.skeleton,
    text = _ref.text,
    _ref$textComponent = _ref.textComponent,
    textComponent = _ref$textComponent === void 0 ? "p" : _ref$textComponent,
    _ref$textVariant = _ref.textVariant,
    textVariant = _ref$textVariant === void 0 ? "body1" : _ref$textVariant,
    textVariants = _ref.textVariants,
    title = _ref.title,
    _ref$titleComponent = _ref.titleComponent,
    titleComponent = _ref$titleComponent === void 0 ? "h3" : _ref$titleComponent,
    _ref$titleVariant = _ref.titleVariant,
    titleVariant = _ref$titleVariant === void 0 ? "h3" : _ref$titleVariant,
    titleVariants = _ref.titleVariants;
  var _useState = (0, _react.useState)(autoplay ? true : false),
    _useState2 = _slicedToArray(_useState, 2),
    play = _useState2[0],
    setPlay = _useState2[1];
  var videoHasPlayed = (0, _react.useRef)(false);
  var css = useStyles();
  var duration = (0, _react.useMemo)(function () {
    return media === null || media === void 0 ? void 0 : media.size;
  }, [media]);
  var formattedTime = (0, _react.useMemo)(function () {
    if (!duration) return;
    var hrs = ~~(duration / 3600);
    var mins = ~~(duration % 3600 / 60);
    var secs = ~~duration % 60;
    var time = "";
    if (hrs > 0) {
      time += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }
    time += "" + mins + ":" + (secs < 10 ? "0" : "");
    time += "" + secs;
    return time;
  }, [duration]);
  var handleTogglePlay = function handleTogglePlay() {
    setPlay(function (prevPlay) {
      return !prevPlay;
    });
    if (!videoHasPlayed.current) {
      videoHasPlayed.current = true;
    }
  };
  if (skeleton) return /*#__PURE__*/_react.default.createElement(Skeleton, null);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Grid, {
    className: (0, _clsx2.default)(css.root, "mco-video-02"),
    container: true
  }, /*#__PURE__*/_react.default.createElement(Grid, {
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.wrapper, "mco-video-02__wrapper")
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !(0, _isEmpty.default)(media) && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.imageWrapper, "mco-video-02__image-wrapper"),
    onClick: handleTogglePlay
  }, /*#__PURE__*/_react.default.createElement(Image, {
    media: media,
    mediaFormats: mediaFormats,
    path: mediaPath
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.playIcon, "mco-video-02__play-icon")
  }, /*#__PURE__*/_react.default.createElement(PlayArrowIcon, {
    fontSize: "large"
  }))), !showInOverlay && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx2.default)(css.videoWrapper, "mco-video-02__video-wrapper", _defineProperty({}, css.isVideoVisible, play))
  }, /*#__PURE__*/_react.default.createElement(Video, {
    autoplay: autoplay,
    css: css,
    loop: loop,
    media: media,
    play: play
  }))))), /*#__PURE__*/_react.default.createElement(Grid, {
    className: (0, _clsx2.default)(css.content, "mco-video-02__content"),
    item: true,
    xs: 12,
    md: 6
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    className: "mco-video-02__title",
    component: titleComponent,
    dangerouslySetInnerHTML: {
      __html: title
    },
    variant: titleVariant,
    variants: titleVariants
  }), formattedTime && /*#__PURE__*/_react.default.createElement(Typography, {
    component: additionComponent,
    className: "mco-video-02__time",
    variant: additionVariant,
    variants: additionVariants
  }, formattedTime, " min"), text && /*#__PURE__*/_react.default.createElement(Box, {
    my: 2
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    className: "mco-video-02__text",
    component: textComponent,
    dangerouslySetInnerHTML: {
      __html: text
    },
    variant: textVariant,
    variants: textVariants
  })))), showInOverlay && play && /*#__PURE__*/_react.default.createElement(ReactOverlay, {
    classes: {
      container: css.overlay
    },
    mode: "html",
    noPadding: true,
    setOpen: setPlay,
    size: "xlarge",
    toolbarColor: "primary",
    toolbarInside: true
  }, /*#__PURE__*/_react.default.createElement(Video, {
    css: css,
    loop: loop,
    media: media,
    play: play,
    videoHasPlayed: videoHasPlayed
  })));
};
ReactVideo02.propTypes = {
  additionComponent: _propTypes.default.string,
  additionVariant: _propTypes.default.string,
  additionVariants: _propTypes.default.object,
  media: _propTypes.default.object,
  mediaFormats: _propTypes.default.object,
  mediaPath: _propTypes.default.string,
  showInOverlay: _propTypes.default.bool,
  skeleton: _propTypes.default.bool,
  text: _propTypes.default.string,
  textComponent: _propTypes.default.string,
  textVariant: _propTypes.default.string,
  textVariants: _propTypes.default.object,
  title: _propTypes.default.string,
  titleComponent: _propTypes.default.string,
  titleVariant: _propTypes.default.string,
  titleVariants: _propTypes.default.object
};
var _default = exports.default = ReactVideo02;